<template>
    <div class="container flex flex-col md:flex-row items-center space-x-0 mt-10 md:mt-10  md:space-x-10">
         <div class=" flex flex-col card-box1 items-center md:block mt-12 md:mt-4 h-full w-full ">
            <div class="back md:ml-12 align-center"><img src="../assets/images/icon-brand-recognition.svg" class="mx-auto py-3 " alt=""></div>
            <h2 class="text-xl font-semibold mx-auto p-3 mt-4 text-center">Brand Recognition</h2>
            <p class="mx-auto text-center text-gray-600 md:leading-2 " >Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem necessitatibus fugiat perspiciatis modi labore aut voluptates, architecto saepe voluptas, ipsam ea accusamus ducimus minus temporibus eius libero! Ex, quos doloremque?</p>
         </div>
          <div class=" flex flex-col items-center md:block card-box2 mt-12 md:mt-36 md:mt-4 mb-5 md:mb-0 w-full h-full">
            <div class="back md:ml-12 align-center "> <img src="../assets/images/icon-detailed-records.svg" class="mx-auto py-3 " alt=""></div>
            <h2 class="text-xl font-semibold mx-auto p-3 mt-4 text-center">Detailed Records</h2>
            <p class="mx-auto text-center text-gray-600">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem necessitatibus fugiat perspiciatis modi labore aut voluptates, architecto saepe voluptas, ipsam ea accusamus ducimus minus temporibus eius libero! Ex, quos doloremque?</p>
         </div>
          <div class="flex flex-col card-box3 items-center md:block mt-12 md:mt-60 md:mt-4 w-full h-full ">
            <div class="back  md:ml-12 "> <img src="../assets/images/icon-fully-customizable.svg" class="mx-auto py-3 " alt=""></div>
            <h2 class="text-xl font-semibold mx-auto p-3 mt-4 text-center">Fully Customisable</h2>
            <p class="mx-auto text-center text-gray-600">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem necessitatibus fugiat perspiciatis modi labore aut voluptates, architecto saepe voluptas, ipsam ea accusamus ducimus minus temporibus eius libero! Ex, quos doloremque?</p>
         </div>   
    </div>
</template>

<script>
    export default{ 
        name: 'Card',
    }
</script>

<style>
    .card-box1{
    width: 367px    ;
    height: 240px;
    background: #FFF;
    border-radius: 10px;
    }
     .card-box2{
    width: 367px    ;
    height: 240px;
    background: #FFF;
    border-radius: 10px;
    }
     .card-box3{
    width: 367px    ;
    height: 240px;
    background: #FFF;
    border-radius: 10px;
    }

    .back{
      height: 70px;
      width: 70px;
      background-color: hsl(257, 27%, 26%);
      border-radius: 400px;
      margin-top:-40px ;
      /* margin-left: 40px; */
    }
    
    
</style>